import { Button } from '@talentmesh/ui/components/button';
import { cn } from '@talentmesh/ui/lib/utils';
import { ChevronDown, ChevronUp } from 'lucide-react';
import React from 'react';

export interface BaseFilterButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    label: string;
    open: boolean;
    activeFilterCount: number;
}

function BaseFilterButton({ label, open, activeFilterCount, ...props }: BaseFilterButtonProps) {
    const countLabel = activeFilterCount > 0 ? `(+${activeFilterCount})` : '';

    return (
        <Button
            variant="ghost"
            size="xs"
            aria-expanded={open}
            className={cn('transition-colors', open ? 'bg-accent text-primary' : 'text-muted-foreground')}
            data-cy="AdvancedFilterButton"
            {...props}
        >
            {`${label} ${countLabel}`}
            {open ? (
                <ChevronUp className="ml-2 h-4 w-4 shrink-0 opacity-50" />
            ) : (
                <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
            )}
        </Button>
    );
}

export default BaseFilterButton;
